import type { CSSProperties } from 'react';

export const timeOffDetailSection: CSSProperties = {
  border: '1px solid var(--ops-border, #e5e7eb)',
  borderRadius: 10,
  background: 'var(--ops-panel-bg, #f8fafc)',
  padding: '0.75rem 1rem'
};

export const timeOffDetailRowLabel: CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: 'var(--ops-color-muted, #64748b)',
  marginBottom: 4
};
